import { parse } from "yaml";
export async function fetchText(url: string) {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error(`Failed ${url}: ${res.status}`);
    return res.text();
}
export async function fetchYaml<T>(url: string): Promise<T> {
    return parse(await fetchText(url), {}) as T;
}
